import Icon from '../components/Icon.vue'

Icon.register({
  'stop-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM352 336v-160c0-8.8-7.2-16-16-16h-160c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})
